import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import Typo from 'constants/typography'
import Icon from 'components/common/icon'
import { ICON_SIZE } from 'components/common/icon/const'
import USPSkeleton from './skeleton'
import styles from './styles.scss'

const USP = ({
  children,
  dataCy,
  hidden,
  icon,
  isFetching,
  onClickOpenModal,
  usp,
  isShowDivider,
}) => {
  if (hidden) {
    return null
  }
  if (isFetching) {
    return <USPSkeleton />
  }

  const { cta, title, description } = usp
  const handleClickOpenModal = () => onClickOpenModal(true)

  return (
    <div
      className={clsx('pdp__usp-container__options', {
        'pdp__usp-container__options__divider': isShowDivider,
      })}
      key={title.key}
      data-cy={dataCy}
    >
      <style jsx>{styles}</style>
      <div className="pdp__usp-container__icons">
        <Icon src={icon} size={ICON_SIZE.medium} />
      </div>
      <div className="pdp__usp-container__informations">
        <div className={Typo.body2}>{title}</div>
        {description && (
          <div
            className={clsx(
              Typo.caption,
              'pdp__usp-container__options__description',
            )}
          >
            {description}
          </div>
        )}

        {cta && (
          <div
            className={clsx('pdp__usp-modal-link', Typo.overline)}
            onClick={handleClickOpenModal}
            onKeyDown={handleClickOpenModal}
            role="button"
            tabIndex={0}
          >
            {cta}
          </div>
        )}
        {children}
      </div>
    </div>
  )
}

USP.defaultProps = {
  hidden: undefined,
  children: undefined,
  isShowDivider: false,
  isFetching: undefined,
  onClickOpenModal: undefined,
}

USP.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.string,
    PropTypes.number,
  ]),
  dataCy: PropTypes.string.isRequired,
  hidden: PropTypes.bool,
  icon: PropTypes.string.isRequired,
  isFetching: PropTypes.bool,
  onClickOpenModal: PropTypes.func,
  usp: PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
    cta: PropTypes.string,
  }).isRequired,
  isShowDivider: PropTypes.bool,
}

export default USP
